// API URL configuration
export const API_URL = import.meta.env.VITE_API_URL || (
  import.meta.env.MODE === 'development' 
    ? 'http://localhost:3001' 
    : ''  // Empty string means use relative paths in production
);

// Firebase Function URL for production (if you have one deployed)
export const FIREBASE_FUNCTION_URL = import.meta.env.VITE_FIREBASE_FUNCTION_URL || '';

// Other configuration values can be added here 